$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'
DowngradePeriodBanner = require 'views/board-limits/downgrade-period-banner'

module.exports = class DowngradePeriodBannerView extends View
  initialize: (model, modelCache) ->
    @$reactRoot ?= $('<div></div>')
    @bannerState = false

  setShown: (bannerShown) =>
    @bannerState = bannerShown

  isShown: =>
    @bannerState

  renderContent: ->
    React.createElement DowngradePeriodBanner,
      model: @model
      modelCache: @modelCache
      setShown: @setShown

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @renderContent()

  render: ->
    @$el.append(@$reactRoot)
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])
    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-limits/downgrade-period-banner-view.coffee